// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 12px;
    box-sizing: border-box;
    background: #2c2c2c;
    font-family: "Microsoft JhengHei";
}

.game-layout {
    display: grid;
    grid-template-columns: minmax(320px, 72vmin) 240px;
    gap: 12px;
    align-items: start;
}

.game-surface {
    width: 100%;
}

#game-world {
    width: 100%;
    aspect-ratio: 1;
}

#game-map,
#game-canvas {
    background-color: #c7c7c7;
    width: 100%;
    height: 100%;
}

#game-map {
    display: grid;
    grid-template-rows: repeat(41, 1fr);
    grid-template-columns: repeat(41, 1fr);
}

#game-canvas {
    display: block;
}

#game-map[hidden],
#game-canvas[hidden] {
    display: none;
}

.game-countdown {
    font-size: 3rem;
    font-weight: 900;
    color: #fa9e2d;
    text-align: center;
    text-shadow: -1px 0 #524f4d, 0 1px #524f4d, 1px 0 #524f4d, 0 -1px #524f4d;
    margin: auto;
}

.game-control-area {
    background-color: #c7c7c7;
    width: 100%;
    min-height: 64px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.area-margin-top {
    margin-top: 0.5vmin;
}

.area-margin-bottom {
    margin-bottom: 0.5vmin;
}

.control-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.renderer-mode-control {
    display: flex;
    align-items: center;
    gap: 6px;
    padding-left: 8px;
    color: #2c2c2c;
    font-size: 0.875rem;
}

.renderer-mode-select {
    max-width: 90px;
    padding: 4px;
    border: 1px solid #7a7a7a;
    border-radius: 4px;
    background-color: #ffffff;
    color: #2c2c2c;
}

.button {
    border-radius: 4px;
    padding: 6px 8px;
    margin: 2px;
    cursor: pointer;
}

.start-button {
    color: #ffffff;
    background-color: #389472;
}

.pause-button {
    color: #ffffff;
    background-color: #945e38;
}

.finish-button {
    color: #ffffff;
    background-color: #943838;
}

.performance-panel {
    background: #f4f4f4;
    border-left: 4px solid #389472;
    color: #2c2c2c;
}

.performance-panel h2 {
    margin: 0;
    padding: 12px;
    border-bottom: 1px solid #c7c7c7;
    font-size: 1rem;
}

.performance-panel dl {
    margin: 0;
}

.performance-panel dl > div {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    padding: 9px 12px;
    border-bottom: 1px solid #dddddd;
}

.performance-panel dt {
    color: #555555;
    font-size: 0.75rem;
}

.performance-panel dd {
    margin: 0;
    font-family: Consolas, monospace;
    font-size: 0.75rem;
    font-weight: 700;
    text-align: right;
}

@media (max-width: 800px) {
    body {
        align-items: flex-start;
    }

    .game-layout {
        width: min(92vmin, 640px);
        grid-template-columns: minmax(0, 1fr);
    }

    .performance-panel dl {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .performance-panel dl > div {
        grid-template-columns: minmax(0, 1fr);
        gap: 3px;
    }

    .performance-panel dd {
        text-align: left;
    }
}
`, "",{"version":3,"sources":["webpack://./src/style/main.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,kDAAkD;IAClD,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,yBAAyB;IACzB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mCAAmC;IACnC,sCAAsC;AAC1C;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yEAAyE;IACzE,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,QAAQ;IACR,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;QACzB,qCAAqC;IACzC;;IAEA;QACI,aAAa;QACb,gDAAgD;IACpD;;IAEA;QACI,qCAAqC;QACrC,QAAQ;IACZ;;IAEA;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["body {\n    width: 100%;\n    min-height: 100vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n    padding: 12px;\n    box-sizing: border-box;\n    background: #2c2c2c;\n    font-family: \"Microsoft JhengHei\";\n}\n\n.game-layout {\n    display: grid;\n    grid-template-columns: minmax(320px, 72vmin) 240px;\n    gap: 12px;\n    align-items: start;\n}\n\n.game-surface {\n    width: 100%;\n}\n\n#game-world {\n    width: 100%;\n    aspect-ratio: 1;\n}\n\n#game-map,\n#game-canvas {\n    background-color: #c7c7c7;\n    width: 100%;\n    height: 100%;\n}\n\n#game-map {\n    display: grid;\n    grid-template-rows: repeat(41, 1fr);\n    grid-template-columns: repeat(41, 1fr);\n}\n\n#game-canvas {\n    display: block;\n}\n\n#game-map[hidden],\n#game-canvas[hidden] {\n    display: none;\n}\n\n.game-countdown {\n    font-size: 3rem;\n    font-weight: 900;\n    color: #fa9e2d;\n    text-align: center;\n    text-shadow: -1px 0 #524f4d, 0 1px #524f4d, 1px 0 #524f4d, 0 -1px #524f4d;\n    margin: auto;\n}\n\n.game-control-area {\n    background-color: #c7c7c7;\n    width: 100%;\n    min-height: 64px;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.area-margin-top {\n    margin-top: 0.5vmin;\n}\n\n.area-margin-bottom {\n    margin-bottom: 0.5vmin;\n}\n\n.control-button {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.renderer-mode-control {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding-left: 8px;\n    color: #2c2c2c;\n    font-size: 0.875rem;\n}\n\n.renderer-mode-select {\n    max-width: 90px;\n    padding: 4px;\n    border: 1px solid #7a7a7a;\n    border-radius: 4px;\n    background-color: #ffffff;\n    color: #2c2c2c;\n}\n\n.button {\n    border-radius: 4px;\n    padding: 6px 8px;\n    margin: 2px;\n    cursor: pointer;\n}\n\n.start-button {\n    color: #ffffff;\n    background-color: #389472;\n}\n\n.pause-button {\n    color: #ffffff;\n    background-color: #945e38;\n}\n\n.finish-button {\n    color: #ffffff;\n    background-color: #943838;\n}\n\n.performance-panel {\n    background: #f4f4f4;\n    border-left: 4px solid #389472;\n    color: #2c2c2c;\n}\n\n.performance-panel h2 {\n    margin: 0;\n    padding: 12px;\n    border-bottom: 1px solid #c7c7c7;\n    font-size: 1rem;\n}\n\n.performance-panel dl {\n    margin: 0;\n}\n\n.performance-panel dl > div {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 8px;\n    padding: 9px 12px;\n    border-bottom: 1px solid #dddddd;\n}\n\n.performance-panel dt {\n    color: #555555;\n    font-size: 0.75rem;\n}\n\n.performance-panel dd {\n    margin: 0;\n    font-family: Consolas, monospace;\n    font-size: 0.75rem;\n    font-weight: 700;\n    text-align: right;\n}\n\n@media (max-width: 800px) {\n    body {\n        align-items: flex-start;\n    }\n\n    .game-layout {\n        width: min(92vmin, 640px);\n        grid-template-columns: minmax(0, 1fr);\n    }\n\n    .performance-panel dl {\n        display: grid;\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n\n    .performance-panel dl > div {\n        grid-template-columns: minmax(0, 1fr);\n        gap: 3px;\n    }\n\n    .performance-panel dd {\n        text-align: left;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
